export const FETCH_OBLIGATIONS = 'FETCH_OBLIGATIONS';

export const FETCH_UPLOADED_OBLIGATIONS = 'FETCH_UPLOADED_OBLIGATIONS';

export const FETCH_USER_ASSIGNED_COMPANY_CODES = 'FETCH_USER_ASSIGNED_COMPANY_CODES';

export const FETCH_LOOKUP_DATA_FOR_OBLIGATIONS = 'FETCH_LOOKUP_DATA_FOR_OBLIGATIONS';
export const FETCH_LOOKUP_DATA_FOR_OBLIGATIONS_SUCCESS = 'FETCH_LOOKUP_DATA_FOR_OBLIGATIONS_SUCCESS';
export const FETCH_LOOKUP_DATA_FOR_OBLIGATIONS_FAILURE = 'FETCH_LOOKUP_DATA_FOR_OBLIGATIONS_FAILURE';

export const UPDATE_OBLIGATION = 'UPDATE_OBLIGATION';
export const UPDATE_OBLIGATION_SUCCESS = 'UPDATE_OBLIGATION_SUCCESS';
export const UPDATE_OBLIGATION_FAILURE = 'UPDATE_OBLIGATION_FAILURE';

export const CREATE_OBLIGATION = 'CREATE_OBLIGATION';
export const CREATE_OBLIGATION_SUCCESS = 'CREATE_OBLIGATION_SUCCESS';
export const CREATE_OBLIGATION_FAILURE = 'CREATE_OBLIGATION_FAILURE';

export const IMPORT_OBLIGATIONS = 'IMPORT_OBLIGATIONS';
export const IMPORT_OBLIGATIONS_SUCCESS = 'IMPORT_OBLIGATIONS_SUCCESS';
export const IMPORT_OBLIGATIONS_FAILURE = 'IMPORT_OBLIGATIONS_FAILURE';

export const CLEAR_UPLOADED_OBLIGATIONS = 'CLEAR_UPLOADED_OBLIGATIONS';

export const DELETE_OBLIGATION = 'DELETE_OBLIGATION';
export const DELETE_OBLIGATION_SUCCESS = 'DELETE_OBLIGATION_SUCCESS';
export const DELETE_OBLIGATION_FAILURE = 'DELETE_OBLIGATION_FAILURE';
